export type LeaderboardRowInput = {
  anonymous?: boolean | null;
  user_id?: string | null;
  name?: string | null;
  avatar_url?: string | null;
  video_count?: number;
};

export type LeaderboardRowDisplay = {
  isAnonymous: boolean;
  name: string | null;
  avatarUrl: string | null;
  showVideoCount: boolean;
};

export function leaderboardRowDisplay(entry: LeaderboardRowInput): LeaderboardRowDisplay {
  const identityRedacted = entry.user_id == null && !entry.name && !entry.avatar_url;
  if (entry.anonymous || identityRedacted) {
    return {
      isAnonymous: true,
      name: null,
      avatarUrl: null,
      showVideoCount: false,
    };
  }
  return {
    isAnonymous: false,
    name: entry.name || '',
    avatarUrl: entry.avatar_url ?? null,
    showVideoCount: true,
  };
}
